import type { AppLoadContext } from "@remix-run/cloudflare"
import { environment, environmentBrowsor } from "../env"

type stringReco = {
  [key: string]: string | number
}

export const generateResizeUrl = (
  path: string,
  param?: stringReco,
  context?: AppLoadContext,
  _basePath?: string,
) => {
  let baseUrl: string;

  // ベースURLの決定
  if (typeof window === "undefined") {
    if (!context) {
      baseUrl = `${_basePath}/img/resize/${path}`
    } else {
      const env = environment(context)
      baseUrl = `${env.WORKER_URL}/img/resize/${path}`
    }
  } else {
    const env = environmentBrowsor()
    baseUrl = `${env.WORKER_URL}/img/resize/${path}`
  }

  // パラメータがない場合はベースURLをそのまま返す
  if (!param) {
    return baseUrl;
  }

  // パラメータをクエリ文字列に変換
  const queryParams = Object.entries(param)
    .filter(([_, value]) => value !== undefined && value !== null && value !== '')
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');

  // クエリパラメータがある場合は追加して返す
  return queryParams ? `${baseUrl}?${queryParams}` : baseUrl;
}


export const generateFileURL = (
  keyPath: string,
  context?: AppLoadContext,
  _basePath?: string,
) => {
  if (typeof window === "undefined") {
    if (!context) {
      return `${_basePath}/${keyPath}`
    }
    const env = environment(context)
    const basePath = generateFileURLBasePath({ ...env, DB_ENV: env.DB_ENV ?? "local" })
    return `${basePath}/${keyPath}`
  } else {
    const env = environmentBrowsor()
    const basePath = generateFileURLBasePath({ ...env, DB_ENV: env.DB_ENV ?? "local" })
    return `${basePath}/${keyPath}`
  }
}

export const generateFileURLBasePath = (
  param: {
    DB_ENV: string,
    WORKER_URL: string,
    R2_PUBLIC_URL: string,
  }
) => {
  const {
    DB_ENV,
    WORKER_URL,
    R2_PUBLIC_URL,
  } = param
  if (typeof window === "undefined") {
    if (DB_ENV === "prd") {
      return `${R2_PUBLIC_URL}`
    }
    if (DB_ENV === "dev") {
      return `${R2_PUBLIC_URL}`
    }
    return `${WORKER_URL}/img/localR2`
  } else {
    if (DB_ENV === "prd") {
      return `${R2_PUBLIC_URL}`
    }
    if (DB_ENV === "dev") {
      return `${R2_PUBLIC_URL}`
    }
    return `${WORKER_URL}/img/localR2`
  }
}

